// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"e3096836","799":"e3096836"}[chunkId] + ".chunk.css";
};